import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { GbeEndPointV4 } from '@core/models/gbe/gbe-endpoint.enum';
import {
  RecipeParameterSchema,
  RecipeParameterSchemaResponse
} from '@core/models/recipe-parameters.model';
import { GBE_BASE_URL } from '@core/tokens/gbe-url.token';

export function recipeParametersSchemaPath(recipeId: number): string {
  return `${GbeEndPointV4.RECIPES}/${recipeId}/parameters-schema`;
}

@Injectable({ providedIn: 'root' })
export class RecipeParametersService {
  private readonly http = inject(HttpClient);
  private readonly gbeUrl = inject(GBE_BASE_URL);

  /**
   * The JSON Schema of the values a recipe needs at plan creation. A schema with
   * empty `properties` means the recipe takes no parameters.
   *
   * Pure function of the recipe on the data-layer side — no user or data-space
   * context — so it is safe to call freely and to cache per recipe.
   */
  getSchemaForRecipe$(recipeId: number): Observable<RecipeParameterSchema> {
    const url = `${this.gbeUrl}/${recipeParametersSchemaPath(recipeId)}`;
    return this.http
      .get<RecipeParameterSchemaResponse>(url)
      .pipe(map((response) => response?.schema ?? {}));
  }
}
